export default __webpack_public_path__ + "static/thirdplace-icon-b34311e0b735523fc6eea2b947488a61.png";